import { render, staticRenderFns } from "./ModalActivities.vue?vue&type=template&id=646cb0d0"
import script from "./ModalActivities.vue?vue&type=script&lang=js"
export * from "./ModalActivities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports